export interface IndustrySector{
    id: number,
    nameInEnglish: string,
    nameInArabic: string,
    industryCriticalCodesId?: number,
    feilds?:any[]
  }
  export class IndustrySectorModel{
    id: 0;
    nameInEnglish: "";
    nameInArabic: "";
    industryCriticalCodesId?: 0;
    fields:[]
  }